<template>
  <div :class="size || 'tw:size-10'" class="tw:relative tw:cursor-pointer">
    <svg class="tw:w-full tw:h-full tw:rounded-full" viewBox="0 0 100 100">
      <circle :class="circleColor" cx="50" cy="50" fill="none" r="45" stroke="currentColor" stroke-width="10" />
      <circle
        :class="progressColor"
        :stroke-dashoffset="dashOffset"
        cx="50"
        cy="50"
        fill="none"
        r="45"
        stroke="currentColor"
        stroke-dasharray="283"
        stroke-width="10"
        transform="rotate(-90 50 50)"
      />
    </svg>
    <div class="tw:absolute tw:inset-0 tw:flex tw:items-center tw:justify-center">
      <i v-if="loading" class="fa-light fa-loader tw:!size-5 tw:text-black" />
      <slot v-else name="default">
        <FontAwesomeIcon
          v-if="icon"
          :icon="icon"
          :class="[iconColor || progressColor, iconSize || 'tw:text-xl']"
          :style="iconStyle"
        />
      </slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref, watch } from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

interface Props {
  progress: number;
  disabled?: boolean;
  icon?: string;
  iconColor?: string;
  iconSize?: string;
  iconStyle?: Record<string, string>;
  size?: string;
  loading?: boolean;
}
const props = defineProps<Props>();

const dashOffset = computed(() => 283 - (Math.min(props.progress, 100) / 100) * 283);

const circleColor = ref("tw:text-default-100");
const progressColor = ref("tw:text-default-500");

watch(
  [() => props.progress, () => props.loading, () => props.disabled],
  ([newProgress, loading, disabled]) => {
    if (loading) {
      circleColor.value = "tw:text-default-100";
      progressColor.value = "tw:text-default-500";
      return;
    }
    if (disabled) {
      circleColor.value = "tw:text-default-100";
      progressColor.value = "tw:text-default-500";
      return;
    }
    if (newProgress <= 25) {
      circleColor.value = "tw:text-red-100";
      progressColor.value = "tw:text-red-500";
    } else {
      circleColor.value = "tw:text-green-100";
      progressColor.value = "tw:text-green-500";
    }
  },
  { immediate: true }
);
</script>
